import { render, staticRenderFns } from "./industry2.vue?vue&type=template&id=550f9bc2&scoped=true"
import script from "./industry2.vue?vue&type=script&lang=js"
export * from "./industry2.vue?vue&type=script&lang=js"
import style0 from "./industry2.vue?vue&type=style&index=0&id=550f9bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f9bc2",
  null
  
)

export default component.exports